import { render, staticRenderFns } from "./DeletedAccount.vue?vue&type=template&id=89770116&"
import script from "./DeletedAccount.vue?vue&type=script&lang=js&"
export * from "./DeletedAccount.vue?vue&type=script&lang=js&"
import style0 from "./DeletedAccount.vue?vue&type=style&index=0&id=89770116&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports